import React, { useState, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  Grid,
  Box
} from "@mui/material";
import { useSnackbar } from 'notistack';
import { ACTIONS, MESSAGES } from '../../../shared/constants';
import DataTable from '../../../shared/data-table';
import {
  saveCampaignTarget,
  getAllCampaigns,
  getSelectedNewsletter,
  getSelectedCampaign,
  getAllCampaignStates,
  getAllCustomers,
  getAllCompanies,
  getAllNewsletterTypes,
  getAllEmployeePositions,
  getAllAirports,
  getResportStateData,
  getListAssessment,
  getAllCampaignContentTypes,
  getAllNewsLetterContentTypes,
  getAssessmentReportByNewsletterIdData,
  getAllNewsletters
} from './logic';
import CampaingSource from '../campaing-detail/campaing-source';
import NewsletterStateReport from '../newsletter-state-report';
import CampaignStateReport from '../campaing-detail/campaing-state-report';
import Edit from '@mui/icons-material/Edit';
import AddCircle from '@mui/icons-material/AddCircle';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { FormatDateToStringComplete } from '../../../shared/functions';
import ErrorSnackbar from '../../error-snackbar';
import BackDrop from '../../../shared/backdropDE';
import { getUser } from '../../../shared/auth-service';

const CampaingDetail = () => {
  const user = getUser();
  const [loading, setLoading] = useState(true);
  const [dataCampaign, setDataCampaign] = useState(null);
  const [data, setData] = useState(null);
  const [dataNewsletter, setDataNewsletter] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [id, setId] = useState(null);
  const [newsletterId, setNewsletterId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModalSource, setShowModalSource] = useState(null);
  const [showModalState, setshowModalState] = useState(null);
  const [showModalSate, setShowModalState] = useState(null);
  const [action, setAction] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [campaignStates, setCampaignStates] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [campaignTypes, setCampaignTypes] = useState([]);
  const [employeePositions, setEmployeePositions] = useState([]);
  const [airports, setAirports] = useState([]);
  const [name, setName] = useState(null);
  const [error, setError] = useState(null);
  const [assessments, setAssessments ] = useState([]);
  const [campaignContentTypes, setCampaignContentTypes ] = useState([]);
  const [onlyEnabledCustomerEmployees, setOnlyEnabledCustomerEmployees ] = useState(false);
  const [dataEmployee, setDataEmployee] = useState(null);
  const [selectedAirport, setSelectedAirport] = useState(0);
  const [employee, setEmployee] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const positions = [47, 56, 95, 60, 611];
  const companyId = user.countryCode.split('-')[0];
  const employeeIdSession = user.employeeId;
  useEffect(() => {
    async function fetchData() {
      if (loading) {
        try {
          const dataEmployee = [];//await getEmployees(companyId);
          var airportsData = user.airports;
          
          var position = user.employeePosition.id;
          //if (positions.includes(position)) 
            airportsData = await getAllAirports(companyId);

          setSelectedAirport(user.airport.id);
          setDataEmployee(dataEmployee);

          const data = await getAllCampaigns(user.employeeId, companyId);
          const dataNewsletter = await getAllNewsletters(user.employeeId, companyId);
          const campaignStatesData = await getAllCampaignStates(companyId);
          const customersData = await getAllCustomers(companyId);
          //const companiesData = await getAllCompanies();
          //const newsletterTypesData = await getAllNewsletterTypes(companyId);
          //const employeePositionsData = await getAllEmployeePositions(companyId);
          //const airportsData = await getAllAirports(companyId);
          //const assessmentData  = await getListAssessment(companyId);
          const campaignContentTypesData = await getAllCampaignContentTypes();
          setCampaignContentTypes(campaignContentTypesData); 
          setDataCampaign(data);
          setDataNewsletter(dataNewsletter);
          setCompanies(user.companies);
          //setAssessments(assessmentData); 
          //setEmployeePositions(employeePositionsData);
          setCampaignStates(campaignStatesData);
          setCustomers(customersData);
          //setCampaignTypes(newsletterTypesData);
          setAirports(airportsData);
          setData(data);
          setLoading(false);
        } catch (error) {
          setError(error.message);
          setLoading(false);
        }
      }
    }
    fetchData();
  }, [loading]);

  useEffect(() => {
    async function fetchRow() {
      if (id) {
        setLoadingDetail(true);
        try {
          if (action === ACTIONS.VIEW_STATE) {
            const data = await getResportStateData(id);
            setReportData(data);
            setId(null);
            setshowModalState(true);
            return;
          }

          if (action === ACTIONS.VIEW_ASSESSMENT_STATE) {
            const data = await getAssessmentReportByNewsletterIdData(id);
            setReportData(data);
            setId(null);
            setShowModalState(true);
            return;
          }

          if (action == ACTIONS.VIEW_STATE || action === ACTIONS.EDIT_SOURCES) {
            const item = await getSelectedCampaign(id);
            setSelectedItem(item);
            setId(null);
            if (action === ACTIONS.EDIT_SOURCES) {
              setShowModalSource(true);
            }
            return;
          }
          if (action == ACTIONS.VIEW_ASSESSMENT_STATE) {
            const data = await getResportStateData(id);
            setReportData(data);
            setId(null);
            setShowModalState(true);
            return;
          }
        } catch (error) {
          setError(error.message);
          setId(null);
        } finally {
          setLoadingDetail(false);
        }
      }
    }
    fetchRow();
  });


  const handleSaveSources = async (
    Id,
    Date,
    endDate,
    CampaignStateId,
    Name,
    CustomerId,
    SelectedEmployeePositions,
    SelectedAirports,
    ContentNewsletter,
    ContentActivity,
    SelectedPersons,
    CompanyId
    ) => {

    const newListContentNewsletter = ContentNewsletter.map(x => ({
      ...x,
      id: x.id.split('-')[1]
    }));

    await saveCampaignTarget(
      {
        Id,
        startDate: Date,
        endDate,
        CampaignStateId,
        Name,
        CustomerId,
        SelectedEmployeePositions,
        SelectedAirports,
        newListContentNewsletter,
        ContentActivity,
        SelectedPersons,
        CompanyId,
        employeeIdSession
      }
    );
    setShowModalSource(false);
    setLoading(true);
    enqueueSnackbar(MESSAGES.SAVED);
  };

  const handleNew = async () => {
    setSelectedItem({});
    setId(null);
    setAction(ACTIONS.NEW);
    setShowModalSource(true);
  };

  const handleActionButton = (e, cellValues, action) => {
    e.stopPropagation();
    setId(cellValues.row.id);
    setNewsletterId(cellValues.row.id);
    setName(cellValues.row.name);
    setAction(action);
  };

   if (loading || loadingDetail) {
      return (
        <BackDrop />
      );
    }

  const columns = [
    {
      field: "EditSources",
      headerName: "Editar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          color="info"
          onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.EDIT_SOURCES) }}
        >
          <Edit />
        </IconButton>;
      }
    },
    {
      field: "ViewState",
      headerName: "Ver",
      headerAlign: 'center',
      align: 'center',
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          color="success"
          onClick={(e) => { handleActionButton(e, cellValues, ACTIONS.VIEW_STATE) }}
        >
          <QueryStatsIcon />
        </IconButton>;
      }
    },
    { field: 'id', headerName: 'Id', width: 50, headerAlign: 'center', align: 'center' },
    { field: 'name', headerName: 'Nombre', width: 600 },
    {
      field: 'startDate', headerName: 'Fecha Desde', headerAlign: 'center', align: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? FormatDateToStringComplete(cellValues.value) : null;
      }, width: 110
    },
    {
      field: 'endDate', headerName: 'Fecha Hasta', headerAlign: 'center', align: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? FormatDateToStringComplete(cellValues.value) : null;
      }, width: 100
    },
    {
      field: 'customerName', headerName: 'Emisor/Cliente', headerAlign: 'center', align: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? cellValues.value.name : null;
      }, width: 250
    },
    {
      field: 'campaignStateName', headerName: 'Estado', headerAlign: 'center', align: 'center',
      renderCell: (cellValues) => {
        return cellValues.value ? cellValues.value.name : null;
      }, width: 120
    }
  ];

  if (loading || loadingDetail) {
    return (
      <BackDrop />
    );
  }

  if (error) {
    return (<ErrorSnackbar message={error} />);
  }

  return (
    <>

      {showModalState && <CampaignStateReport
         name={`Estado evaluación circular ${name}`}
         reportData={reportData}
         handleClose={setShowModalState}
         id={newsletterId}
      />}

      {showModalSource && <CampaingSource
        data={selectedItem}
        allNewsletter={dataNewsletter}
        handleClose={setShowModalSource}
        handleSaveSources={handleSaveSources}
        airports={airports}
        customers={customers}
        companies={companies}
        employeePositions={employeePositions}
        newsletterTypes={campaignTypes}
        newsletterStates={campaignStates}
        assessments={assessments}
        campaignContentTypes={campaignContentTypes}
        airportId={selectedAirport}
        employeeId={employeeId}
        action={action}
        onlyEnabledCustomerEmployees={onlyEnabledCustomerEmployees}
      />}

      {showModalState && <CampaignStateReport
        name={name}
        reportData={reportData}
        handleClose={setshowModalState}
        airports={airports}
        employeePositions={employeePositions}
      />}
      {error && <ErrorSnackbar message={error} />

      }
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ flexGrow: 1, m: 1, }}>
            Campañas
          </Typography>
          {/* <Typography variant="h5" gutterBottom>
                {`${TITLES.NEWSLETTER}`}
              </Typography> */}
        </Grid>
        <Box sx={{ m: 4 }}>
          <Grid item xs={2}>
            <Button
              endIcon={<AddCircle />}
              variant="contained"
              onClick={() => { handleNew() }} autoFocus>{ACTIONS.NEW}</Button>
          </Grid>
        </Box>
      </Grid>
      <DataTable columns={columns} rows={data || []} 
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold', // Aplicar negrita a los títulos de las columnas
          }
        }}
      />
    </>
  );
};

export default CampaingDetail;
